import { render, staticRenderFns, recyclableRender, components } from "./commentManger.vue?vue&type=template&id=eec2c3a6&"
var renderjs
import script from "./commentManger.vue?vue&type=script&lang=js&"
export * from "./commentManger.vue?vue&type=script&lang=js&"
import style0 from "./commentManger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/commentManger/commentManger.vue"
export default component.exports